$(document).ready(function(){

    validateForm({
        formId: 'form-calc'
        //formValidClass: 'Form_valid',
        //formInvalidClass: 'Form_invalid',
        //inputErrorClass: 'Input_error'
    });

    validateForm({
        formId: 'form-person-1'
        //formValidClass: 'Form_valid',
        //formInvalidClass: 'Form_invalid',
        //inputErrorClass: 'Input_error'
    });

    $('.ProjectCardSlider-SliderWrap').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        arrows: true,
        dots: false,
        prevArrow: '<button type="button"\n' +
        '                                            class="Slider-Arrow Slider-Arrow-Prev">\n' +
        '                                        <svg width="9" height="14">\n' +
        '                                            <use\n' +
        '                                                xlink:href="/img/sprite.svg#arrow-slider"\n' +
        '                                                href="/img/sprite.svg#arrow-slider"></use>\n' +
        '                                        </svg>\n' +
        '                                    </button>',
        nextArrow: '<button type="button"\n' +
        '                                            class="Slider-Arrow Slider-Arrow-Next">\n' +
        '                                        <svg width="9" height="14">\n' +
        '                                            <use\n' +
        '                                                    xlink:href="/img/sprite.svg#arrow-slider"\n' +
        '                                                    href="/img/sprite.svg#arrow-slider"></use>\n' +
        '                                        </svg>\n' +
        '                                    </button>'
    });
});